<template>
  <div v-loading="loading" class="base-card-info rounded-sm p-3">
    <div class="info-card-title mb-3">
      消息通知
    </div>

    <template v-if="!loading">
      <el-empty
        v-if="!messages.length"
        class="w-full flex justify-center items-center pt-[50px]"
        description="暂无消息通知"
        :image-size="80"
      />

      <el-scrollbar v-else class="max-h-[320px]" scrollbar-y>
        <div class="gap-4 flex flex-col w-full">
          <div v-for="(v, idx) in messages" :key="idx" class="msg-item">
            <div>
              <div class="msg-tag">
                <strong class="text-[##d9d9d9]">•</strong>
              </div>
              <div class="flex-1 mr-2" :title="v.content">
                【{{ v.title }}】{{ v.content }}
              </div>
            </div>
            <div class="w-[70px]">
              <!-- {{ v.createTime }} -->
            </div>
          </div>
        </div>
      </el-scrollbar>
    </template>
  </div>
</template>

<script setup lang="ts">
import dayjs from 'dayjs';
import { IMessageNotice } from '@core/main/types/home';
import { ref } from 'vue';

const messages = ref<IMessageNotice[]>([
  {
    title: '系统通知',
    content: '您好，欢迎使用本系统！',
    createTime: dayjs().format('YYYY-MM-DD'),
  },
]);
const loading = ref(false);
</script>

<style scoped lang="scss">
.msg-item {
  @apply text-[#8c8c8c] text-[12px] flex justify-between items-center;

  & > div {
    &:first-child {
      @apply flex-1 flex;
    }

    &:last-child {
      @apply ml-2 w-[70px] text-right;
    }
  }
}

.msg-tag {
  & + div {
    @apply text-ellipsis overflow-hidden whitespace-nowrap w-[150px];
  }
}
</style>
